import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { DadosModal } from 'app/interfaces/AgView-connect';

@Component({
  selector: 'app-configs-modal',
  standalone: true,
  imports: [MatDialogModule, TranslocoModule],
  templateUrl: './configs-modal.component.html',
  styleUrl: './configs-modal.component.css'
})
export class ConfigsModalComponent implements OnInit {
  @Output() eventoModal = new EventEmitter<number[] | undefined>();
  @Input() configs!: DadosModal;
  @Input() valoresSelecionados!: number[];
  @Input() controladoresSensoresEmUso!: number[];
  public maxExcedido: boolean = false;
  public contraladorSelecionadoEmUso = false;
  public controladorEmUso: number = 0;
  public itensSelecionados!: number[];

  ngOnInit(): void {
    this.itensSelecionados = [...this.valoresSelecionados];
  }

  public fecharModal(): void {
    this.eventoModal.emit()
  }

  public enviarDados(): void {
    this.eventoModal.emit(this.itensSelecionados.sort((a, b) => a - b))
  }

  public alternarControladoraSensor(valor: number): void {
    if (this.itensSelecionados.includes(valor)) {
      this.itensSelecionados = this.itensSelecionados.filter(valorArray => valorArray !== valor);
      this.maxExcedido = this.verificarMaxExcedido();
    } else {
      this.addControladoraSensor(valor)
    }
  }

  public verificarMaxExcedido(): boolean {
    return this.itensSelecionados.length + 1 > this.configs.quantMax;
  }

  public verificarUso(valor: number): boolean {
    const controladorEmUso = this.controladoresSensoresEmUso.includes(valor);
    if (controladorEmUso) {
      this.controladorEmUso = valor;
    }
    return controladorEmUso;
  }

  public addControladoraSensor(valor: number): void {
    this.maxExcedido = this.verificarMaxExcedido();
    if (this.maxExcedido) return;
    this.contraladorSelecionadoEmUso = this.verificarUso(valor);
    if (this.contraladorSelecionadoEmUso) return;
    this.itensSelecionados.push(valor);
  }

}
